var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1725_2049)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.284 22c-.016-2.207-.705-4.182-2.11-5.877-1.56-1.884-3.563-3.03-6.006-3.32-2.825-.34-5.306.451-7.416 2.362-1.727 1.566-2.707 3.53-2.976 5.85-.037.328-.037.656-.053.984H.006v-.645c.06-.425.097-.85.172-1.27.404-2.314 1.458-4.29 3.132-5.936a10.841 10.841 0 013.923-2.481c.043-.016.086-.038.151-.07-1.792-1.351-2.755-3.11-2.728-5.355.021-1.722.672-3.213 1.905-4.418 2.599-2.54 6.581-2.352 8.982.08 2.669 2.713 2.427 7.384-.867 9.666 4.58 1.964 7.158 5.35 7.33 10.43h-1.722zM11.006 1.715C8.46 1.711 6.378 3.788 6.362 6.34c-.017 2.55 2.077 4.65 4.633 4.655 2.546.005 4.628-2.072 4.644-4.623.017-2.55-2.077-4.65-4.633-4.655z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1725_2049"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0H22V22H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.097e44e5.svg";
export { ForwardRef as ReactComponent };